import { IMobileSections, ISections } from "./type";

const LinkSections: ISections = {
  products: {
    text: "Products",
    ariaLabel: "product-menu",
    linkTo: "/products",
    dropListItem: [
      {
        name: "PA100 Series for Government Use",
        imgage: "mPa100",
        description:
          "Built specifically for United States Federal Government Networks, The PA100 series is FIPS 140-3 validated and FISMA-high approved for government installations.",
        slug: "/categories/pa100-government-series-commdevices-com",
        target_label: "View PA100 Products",
      },
      {
        name: "PA200 for Commercial Use",
        imgage: "mPa200",
        description:
          "The PA200 series was designed from the ground up to provide the highest level of security at the most efficient price point.",
        slug: "/categories/pa200-series-for-commercial",
        target_label: "View PA200 Products",
      },
      {
        name: "Power Control System",
        imgage: "mPowerControl",
        description:
          "Empower your engineers to troubleshoot like never before. Power Control Modules (PCMs) are designed to save you time, money, and avoid truck rolls.",
        slug: "/categories/power-control-systems",
        target_label: "View Control System",
      },
      {
        name: "Management Console",
        imgage: "mManagementConsole",
        description:
          "From simple CLI access to full-featured key stroke logging, CDI has a tool to help you make Out-of-Band Management simple and secure.",
        slug: "/categories/management-console",
        target_label: "View Management Console",
      },
      {
        name: "Accessories",
        imgage: "mAccessories",
        description:
          "Power and Cable accessories for all types of installations.",
        slug: "/categories/accessories",
        target_label: "View Accessories",
      },
    ],
  },
  solutions: {
    text: "Solutions",
    ariaLabel: "solution-menu",
    linkTo: "/solutions",
    dropItems: {
      intro: {
        title: "Solutions",
        desc: "Provides your engineers with the ability to use alternate communications that are not part of the network’s bandwidth to access the network’s firewall, routers, bridges, sonnet switches, and servers.",
        goTo: {
          text: "Get in Touch",
          to: "/solutions",
          isHasArrow: true,
        },
      },
      headingLinks: [
        {
          text: "Our Solutions",
          to: "/solutions",
        },
        {
          text: "Use Cases",
          to: "/use-cases",
        },
        {
          text: "About FIPS-FISMA",
          to: "/fisma",
        },
        // {
        //   text: "FIPS 140-3",
        //   to: "/fips-140-2",
        // },
        {
          text: "FIPS 140-3",
          to: "/fips-140-3",
        },
      ],
      variantLinks: [
        {
          text: "Request a Quote",
          to: "/request-a-quote",
        },
        {
          text: "Contact Us",
          to: "/contact-us",
        },
        {
          text: "Call us on 1 800 359-8561",
          to: "",
        },
      ],
    },
  },
  aboutCdi: {
    text: "About  CDI",
    ariaLabel: "about-cdi",
    linkTo: "/about-cdi",
    dropItems: {
      intro: {
        title: "About CDI",
        desc: "Communication Devices Inc (CDI) was incorporated in 1976 as a custom data-communications solutions provider for the newspaper and financial services industries.",
        goTo: {
          text: "Learn More",
          to: "/about-cdi",
          isHasArrow: true,
        },
      },
      headingLinks: [
        {
          text: "About CDI",
          to: "/about-cdi",
        },
        {
          text: "Company History",
          to: "/company-history",
        },
        {
          text: "Our Team",
          to: "/our-team",
        },
      ],
      variantLinks: [
        {
          text: "Certifications",
          to: "/certifications",
        },
        {
          text: "Patents",
          to: "/patents",
        },
        {
          text: "Upcoming Events",
          to: "/upcoming-event",
        },
      ],
    },
  },
  support: {
    text: "Support",
    ariaLabel: "support",
    linkTo: "/support",
    dropItems: {
      intro: {
        title: "Support",
        desc: "The new CDI support center has a much improved help desk ticketing system designed to improve the speed and efficiency of our customer support.",
        goTo: {
          text: "Learn More",
          to: "/support",
          isHasArrow: true,
        },
      },
      headingLinks: [
        {
          text: "Customer Portal Login",
          to: "https://support.commdevices.com/portal/en/signin",
          isExternal: true,
        },
        {
          text: "Resources",
          to: "/resources",
          isExternal: true,
          linkTarget: "_self",
        },
        {
          text: "Product Videos",
          to: "/resources?type=video",
          isExternal: true,
          linkTarget: "_self",
        },
        {
          text: "Download Documentation",
          to: "/resources?type=download",
          isExternal: true,
          linkTarget: "_self",
        },
      ],
      variantLinks: [
        {
          text: "Support",
          to: "/support",
        },
        {
          text: "Contact Us",
          to: "/contact-us",
        },
        {
          text: "FAQs",
          to: "/faqs",
        },
        {
          text: "Blog",
          to: "/our-blog",
        },
      ],
    },
  },
  contactUs: {
    text: "Contact Us",
    ariaLabel: "contactUs",
    linkTo: "/contact-us",
  },
};

export interface IMediaCover {
  heading: string;
  desc: string;
  actions: {
    title: string;
    slug: string;
    type: string;
    variant?: string;
    icon?: string;
  }[];
  media: string;
  color?: string;
}

export default LinkSections;

export const MobileLinkSections: IMobileSections = {
  products: {
    text: "Products",
    ariaLabel: "product-menu",
    dropListItem: [
      {
        name: "Products",
        slug: "/products",
        target_label: "products",
      },
      {
        name: "PA100 Series for Government Use",
        slug: "/categories/pa100-government-series-commdevices-com",
        target_label: "PA100",
      },
      {
        name: "PA200 for Commercial Use",
        slug: "/categories/pa200-series-for-commercial",
        target_label: "View PA200 Products",
      },
      {
        name: "Power Control System",
        slug: "/categories/power-control-systems",
        target_label: "View Control System",
      },
      {
        name: "Management Console",
        slug: "/categories/management-console",
        target_label: "View Management Console",
      },
      {
        name: "Accessories",
        slug: "/categories/accessories",
        target_label: "View Accessories",
      },
    ],
  },
  solutions: {
    text: "Solutions",
    ariaLabel: "solution-menu",

    dropListItem: [
      {
        name: "Our Solutions",
        target_label: "Our Solutions",
        slug: "/solutions",
      },
      {
        name: "Use Cases",
        target_label: "Use Cases",
        slug: "/use-cases",
      },
      {
        name: "About FIPS-FISMA",
        target_label: "About FIPS-FISMA",
        slug: "/fisma",
      },
      // {
      //   name: "FIPS 140-3",
      //   target_label: "FIPS 140-3",
      //   slug: "/fips-140-2",
      // },
      {
        name: "FIPS 140-3",
        target_label: "FIPS 140-3",
        slug: "/fips-140-3",
      },
    ],
  },
  aboutCdi: {
    text: "About  CDI",
    ariaLabel: "about-cdi",
    dropListItem: [
      {
        name: "About CDI",
        target_label: "About CDI",
        slug: "/about-cdi",
      },
      {
        name: "Company History",
        target_label: "Company History",
        slug: "/company-history",
      },
      {
        name: "Our Team",
        target_label: "Our Team",
        slug: "/our-team",
      },
    ],
  },
  support: {
    text: "Support",
    ariaLabel: "support",
    dropListItem: [
      {
        name: "Support",
        target_label: "Support",
        slug: "/support",
      },
      {
        name: "Customer Portal Login",
        target_label: "Customer Portal Login",
        slug: "https://support.commdevices.com/portal/en/signin",
        isExternal: true,
      },
      {
        name: "Resources",
        target_label: "Resources",
        slug: "/resources",
        isExternal: true,
      },
      {
        name: "Product Videos",
        target_label: "Product Videos",
        slug: "/resources?type=video",
        isExternal: true,
      },
      {
        name: "Download Documentation",
        target_label: "Download Documentation",
        slug: "/resources?type=download",
        isExternal: true,
      },
    ],
  },
};
